







































































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import KeycloakStore from '@/stores/user/keycloak.store';
import Routes from '@/util/Routes';
import MobileFlyoutMenu from '@/views/layout/MobileFlyoutMenu.vue';
import StyledSelect, { StyledSelectData } from '@/views/common/StyledSelect.vue';
import UserStore from '@/stores/user/user.store';
import { CmsStore } from '@/stores/cms.store';
import { EventKey } from '@/util/EventKey';
import { HeaderFragmentDto, LinkDto, MenuDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';
import MobileHeaderCmsMenu from '@/views/layout/MobileHeaderCmsMenu.vue';
import { Config } from '@/util/Config';

@Component({
  components: {MobileHeaderCmsMenu, CmsLink, StyledSelect, MobileFlyoutMenu},
})
export default class MobileHeaderMenu extends Vue {
  public routes = Routes;
  public activeMenuIndex = -1;
  private keycloakStore = getModule(KeycloakStore, this.$store);
  public readonly flyoutMenuId = -2;
  public readonly accountMenuId = -3;
  private cmsStore = getModule(CmsStore, this.$store);
  private userStore = getModule(UserStore, this.$store);

  public get hasLanguageOptions(): boolean {
    return this.languages.length > 1;
  }

  // NOTE: This logic is duplicated in MobileHeaderMenu.vue
  public get languages(): Array<StyledSelectData<string>> {
    const languages = Config.LANGUAGES.map(({code, name}: {code: string, name: string}) => {
      return {displayString: name, key: code, value: code};
    });
    if (!languages.some((item: StyledSelectData<string>) => item.key === this.currentLanguage)) {
      languages.push({displayString: this.currentLanguage, key: this.currentLanguage, value: this.currentLanguage});
    }
    return languages;
  }

  get cmsHeader(): HeaderFragmentDto | null {
    return this.cmsStore.header;
  }

  get topLinks(): LinkDto[] {
    return this.cmsHeader?.topLinks ?? [];
  }

  get activeCmsMenu(): MenuDto | null {
    if (this.activeMenuIndex >= 0 && this.activeMenuIndex < this.extraMenus.length) {
      return this.extraMenus[this.activeMenuIndex];
    } else {
      return null;
    }
  }

  get extraMenus(): MenuDto[] {
    return this.cmsHeader?.extraMenus?.filter((menu) => !!menu.mainLink) ?? [];
  }

  get currentLanguage(): string {
    return this.userStore.currentLanguage;
  }

  public get currentSelectedLanguage(): StyledSelectData<string> | null {
    return this.languages.find((lang) => lang.value === this.currentLanguage) ?? null;
  }

  public async changeLanguage(newLanguageName: string, newLangKey: string) {
    if (this.keycloakStore.authenticated) {
      await this.userStore.changeUserLanguage(newLangKey);
    } else {
      this.userStore.setLocalLanguage(newLangKey);
    }
    this.$events.$emit(EventKey.LANGUAGE_CHANGE, newLangKey);
  }

  get authenticated() {
    return this.keycloakStore.authenticated;
  }

  public login(): void {
    this.keycloakStore.login();
  }

  public logout(): void {
    this.keycloakStore.logout();
  }

  public toggleMenu(menuIndex: number): void {
    if (this.isMenuActive(menuIndex)) {
      this.activeMenuIndex = -1;
    } else {
      this.activeMenuIndex = menuIndex;
    }
  }

  public isMenuActive(menuIndex: number): boolean {
    return this.activeMenuIndex === menuIndex;
  }

  public close(): void {
    this.activeMenuIndex = -1;
    this.$emit('close');
  }
}
